import { render, staticRenderFns } from "./Input.vue?vue&type=template&id=d8b38d2c&scoped=true&"
import script from "./Input.vue?vue&type=script&lang=ts&"
export * from "./Input.vue?vue&type=script&lang=ts&"
import style0 from "./Input.vue?vue&type=style&index=0&id=d8b38d2c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8b38d2c",
  null
  
)

export default component.exports